<template>
  <el-card header="会员信息" class="box-card">
    <el-form :model="formData" :rules="rules" ref="dataForm" label-width="100px">
      <el-form-item label="姓名" prop="name">
        <el-input v-model="formData.name" />
      </el-form-item>
      <el-form-item label="手机" prop="mobile">
        <el-input v-model="formData.mobile" />
      </el-form-item>
      <el-form-item label="性别" prop="gender">
        <el-radio-group v-model="formData.gender">
          <el-radio label="M">男</el-radio>
          <el-radio label="F">女</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="备注" prop="comment">
        <el-input type="textarea" size="small" v-model="formData.comment"></el-input>
      </el-form-item>
      <el-form-item label=" ">
        <el-button type="primary" @click="submitForm">提交</el-button>
        <el-button @click="cancel">取消</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>
<script>
export default {
  data () {
    return {
      formData: {
        id: undefined,
        uid: '',
        name: '',
        mobile: '',
        gender: '',
        comment: ''
      },
      rules: {
        name: [{ required: true, message: '请填写姓名', trigger: 'blur' }],
        mobile: [{ required: true, message: '请填写手机', trigger: 'blur' }],
        gender: [{ required: true, type: 'string', message: '请选择性别', trigger: 'change' }]
      }
    }
  },
  created: function () {
    this.formData.id = this.$route.query.id
    if (this.formData.id) {
      this.formData.uid = this.formData.id
      this.fetchData()
    }
  },
  methods: {
    fetchData () {
      var that = this
      that.api.member.get({ id: that.formData.id }).then(response => {
        if (response.data.success) {
          Object.assign(that.formData, response.data.result)
        }
      })
    },
    submitForm () {
      var that = this
      that.$refs['dataForm'].validate((valid) => {
        if (valid) {
          that.api.member.save(Object.assign({}, that.formData)).then(function (response) {
            if (response.data.success) {
              that.$router.go(-1)
            }
          })
        } else {
          return false
        }
      })
    },
    resetForm () {
      this.$refs['dataForm'].resetFields()
    },
    cancel () {
      this.$router.go(-1)
    }
  }
}
</script>


// WEBPACK FOOTER //
// edit.vue?6ce9a51e